// Hosted templates (contract §8.3): a page whose body is one live area the app
// draws (§5): the anchor-watch module, which stays a live area (Q16), a module
// of a kind no template ports yet, and the map, how-to and friend cards. The
// page is the area alone, filling the card body; once edited, Neo may place
// other things beside it. Drawn directly while unedited (§5.6).

import { css, h, output } from "./kit.js";

const LIVE_CSS = css(`
  .hs { padding: 0; }
  .hs tc-live { flex: 1 1 auto; width: 100%; min-height: 96px; }
`);

/** A module of a kind no template ports, or the anchor watch: its module in a live area. */
export function hostedModule(source) {
  const spec = source.spec;
  const live = {
    v: 1,
    kind: "module",
    boatId: spec.boatId,
    module: spec.module,
    mode: spec.mode,
    config: spec.config ?? {},
  };
  return output(`module.${spec.module}`, 1, {
    html: h("div", { class: "tp hs" }, h("tc-live", { id: "module" })),
    css:
      LIVE_CSS +
      (spec.module === "anchor-watch"
        ? css(`.hs tc-live { min-height: 240px; }`)
        : ""),
    live: [{ id: "module", spec: live, rolling: null }],
    card: { kind: "panel", icon: null },
  });
}

/** The map, how-to and friend cards: the card in a live area (§5.2). */
export function hostedCard(id, source) {
  const spec = source.spec;
  let area;
  if (spec.kind === "map") {
    const window = spec.window ?? null;
    area = {
      id: "map",
      spec: {
        v: 1,
        kind: "map",
        boatId: spec.boatId,
        layers: Array.isArray(spec.layers) ? [...spec.layers] : [],
        window,
      },
      rolling:
        window !== null &&
        typeof source.rolling === "number" &&
        Number.isInteger(source.rolling) &&
        source.rolling > 0
          ? source.rolling
          : null,
    };
  } else if (spec.kind === "how-to") {
    area = {
      id: "steps",
      spec: {
        v: 1,
        kind: "how-to",
        boatId: spec.boatId,
        procedureId: spec.procedureId,
      },
      rolling: null,
    };
  } else {
    area = {
      id: "boat",
      // The card's offered change rides with it: the area is the card.
      spec:
        spec.confirm === undefined
          ? { v: 1, kind: "friend", boatId: spec.boatId, mmsi: spec.mmsi }
          : {
              v: 1,
              kind: "friend",
              boatId: spec.boatId,
              mmsi: spec.mmsi,
              confirm: spec.confirm,
            },
      rolling: null,
    };
  }
  return output(id, 1, {
    html: h("div", { class: "tp hs" }, h("tc-live", { id: area.id })),
    css:
      LIVE_CSS +
      (spec.kind === "map" ? css(`.hs tc-live { min-height: 120px; }`) : ""),
    live: [area],
    card: { kind: "panel", icon: null },
  });
}
